export default '25.0';
